export function createSelectBoxYear (from, to) {
    const yearJSON = []
    if (from < to) {
        for (let i = to; i >= from; i--) {
            yearJSON.push({
                label: i,
                value: i
            })
        }
    } else {
        for (let j = to; j <= from; j++) {
            yearJSON.push({
                label: j,
                value: j
            })
        }
    }
    return yearJSON
}

export function createSelectBoxMonth (month, to, val) {
    const monthJSON = []
    for (let i = 1; i <= 12; i++) {
        monthJSON.push({
            label: i,
            value: i
        })
    }
    return monthJSON
}

export function createSelectBoxDayOrMonth (to) {
    const daysJSON = []
    for (let i = 1; i <= to; i++) {
        daysJSON.push({
            label: i,
            value: i
        })
    }
    return daysJSON
}

/**
 * 月末日算出
 **/
export function calcLastDayOfMonth (year, month) {
    let lastDay
    const now = new Date()
    const currentYear = now.getFullYear()
    const currentMonth = now.getMonth()
    if (Number(year) === currentYear && (Number(month) - 1) === currentMonth) {
        lastDay = now.getDate()
    } else if (Number(month) === 2 &&
    (year % 4 === 0)) {
        lastDay = 29
    } else {
        lastDay = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1]
    }
    return lastDay
}
